import React from "react";
import "./ExperienceFlatCard.scss";

export default function ExperienceFlatCard({cardInfo, isDark}) {
  const wrapClass = isDark
    ? "experience-flat-card-dark experience-flat-card--intuit"
    : "experience-flat-card experience-flat-card--intuit";
  const roleClass = isDark
    ? "experience-flat-role-dark dark-mode-text"
    : "experience-flat-role";
  const companyClass = isDark
    ? "experience-flat-company-dark dark-mode-text"
    : "experience-flat-company";
  const dateClass = isDark
    ? "experience-flat-date-dark dark-mode-text"
    : "experience-flat-date";
  const descClass = isDark
    ? "experience-flat-desc-dark dark-mode-text subTitle"
    : "experience-flat-desc subTitle";
  const bulletClass = isDark ? "subTitle dark-mode-text" : "subTitle";

  return (
    <div className={wrapClass}>
      <div className="experience-flat-logo-wrap">
        <img
          className="experience-flat-logo"
          src={cardInfo.companylogo}
          alt={cardInfo.company}
        />
      </div>
      <div className="experience-flat-body">
        <h5 className={roleClass}>{cardInfo.role}</h5>
        <p className={companyClass}>{cardInfo.company}</p>
        <p className={dateClass}>{cardInfo.date}</p>
        {cardInfo.desc ? <p className={descClass}>{cardInfo.desc}</p> : null}
        {cardInfo.descBullets && cardInfo.descBullets.length > 0 ? (
          <ul>
            {cardInfo.descBullets.map((item, i) => (
              <li key={i} className={bulletClass}>
                {item}
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </div>
  );
}
